<div [style.backgroundImage]="'url('+ theme.image ? theme.image : '' +')'">
    <div [innerHTML]="formDetails.theme.headerHtml | safeHtml" class="headerHtml"></div>
    <div class="row m-0">
        <div class="col-lg-6 offset-lg-3 col-md-10 offset-md-1 col-sm-12 offset-sm-0 col-12 offset-0 p-0">
            <div>
                <div *ngIf="formDetails.aboveHTML" class="container mt-3 external-html-wrapper"
                    style="text-align:center" [innerHTML]="formDetails.aboveHTML | safeHtml"></div>
            </div>
            <div class="form-drop-area">
              <h2 class="form-self-title">{{formDetails.name}}</h2>
              <p class="form-self-subtitle mb-3" [innerHtml]="formDetails.description"></p>
              <form *ngIf="formList.length == 0" [formGroup]="formConfig" (submit)="handleNextButton()">
                <div class="row mb-1">
                  <div class="col-md-6 mb-2">
                    <div class="field-input-text">
                      <label>First Name *</label>
                      <input id="firstName" class="form-control" formControlName="firstName"
                             placeholder="First Name" required [(ngModel)]="submission.firstName">

                      <div *ngIf="f.firstName.invalid && (f.firstName.dirty || f.firstName.touched)"
                           class="text-danger fade show" role="alert">

                        <small *ngIf="f.firstName.errors.required">
                          <b>*First Name must be required</b>
                        </small>
                        <small *ngIf="f.firstName.errors.pattern">
                          <b>*First Name must be Valid </b>
                        </small>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 mb-2">
                    <div class="field-input-text">
                      <label>Last Name *</label>
                      <input type="text" class="form-control" formControlName="lastName"
                             placeholder="Last Name" [(ngModel)]="submission.lastName" />
                      <div *ngIf="f.lastName.invalid && (f.lastName.dirty || f.lastName.touched)"
                           class="text-danger fade show" role="alert">

                        <small *ngIf="f.lastName.errors.required">
                          <b> *Last Name must be required</b>
                        </small>
                        <small *ngIf="f.lastName.errors.pattern">
                          <b> *Last Name must be valid</b>
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <div class="field-input-text">
                      <label>Email Address *</label>
                      <input type="text" class="form-control" formControlName="emailAddress"
                             placeholder="Email Adress" [(ngModel)]="submission.emailAddress" />
                      <div *ngIf="f.emailAddress.invalid && (f.emailAddress.dirty || f.emailAddress.touched)"
                           class="text-danger fade show" role="alert">
                        <small *ngIf="f.emailAddress.errors.required">
                          <b>*Email Address must be required</b>
                        </small>
                        <small *ngIf="f.emailAddress.errors.pattern">
                          <b>*Please Enter valid email</b>
                        </small>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-2" *ngIf="!generalSetting.SkipPhoneInBasic">
                    <div class="field-input-text">
                      <label>Phone Number *</label>
                      <input type="text" class="form-control" formControlName="phoneNumber"
                             placeholder="Phone Number" [(ngModel)]="submission.phoneNumber" />
                      <div *ngIf="f.phoneNumber.invalid && (f.phoneNumber.dirty || f.phoneNumber.touched)"
                           class="text-danger fade show" role="alert">
                        <small *ngIf="f.phoneNumber.errors.required">
                          <b> *Phone Number must be required</b>
                        </small>
                        <small *ngIf="f.phoneNumber.errors.pattern">
                          <b>*Please Enter valid phone number</b>
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <div class="field-input-text">
                      <div class="submission-btn">
                        <button type="submit" class="btn submitSub-btn all-btns"> Next </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div *ngIf="formList.length">
                <div *ngFor="let form of formList; index as i">
                  <app-dynamic-form2 *ngIf="form.nodeType !== 0 " [submitOnChange]="form.nodeType == 2"
                                     [fields]="getFields(form, i)" (submit)="submit(i, $event)"></app-dynamic-form2>
                  <div class="col-md-12">
                    <h5 *ngIf="form.nodeType === 0" class="alert alert-warning warning-stick" role="alert">
                      <div class="traingle">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                      </div>
                      &nbsp; &nbsp;&nbsp;
                      <div *ngIf="form.blockedMessage" class="" [innerHTML]="form?.blockedMessage">
                      </div>
                      <div *ngIf="!form.blockedMessage" class="">
                        We are not taking registration for your details, Please visit again later.
                      </div>
                    </h5>
                    <div *ngIf="form.nodeType == 1 && formDetails.showCaptcha">
                      <div #recaptcha ></div>
                    </div>
                  </div>
                </div>
              </div>
              <!--PSOPS-5964-->
              <div class="col-md-6">

                <img *ngIf="formDetails.logoUrl" [src]="formDetails.logoUrl" style="max-width:100px;max-height:100px" class="imgcenter" [alt]="'Logo Url'" />
              </div>
              <!--PSOPS-5964-->
            </div>
            <div>
                <div *ngIf="formDetails.belowHTML" class="container external-html-wrapper" style="text-align:center;margin-bottom: 30px;"
                    [innerHTML]="formDetails.belowHTML | safeHtml"></div>
            </div>
            <div *ngIf="!formDetails.d2LFooter" class="footerText">
                <img src="../../assets//images/D2L_Brightspace_black.svg" alt="D2l Footer Logo"/>
                <div class="footertext">
                    <p>Powered by award winning <span>Brightspace LMS</span></p>
                    <p>© Copyright D2L Corporation. All rights reserved.</p>
                    <p class="lastrow">All D2L marks are trademarks of D2L Corporation. Please visit D2L com/trademarks for a
                        list of D2L marks.</p>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!formDetails.d2LFooter && theme.footerHtml" [innerHTML]="theme.footerHtml">


    </div>
</div>
